import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import LucideIcon from './components/ui/LucideIcon.vue'

const app = createApp(App)

app.component('LucideIcon', LucideIcon)
app.use(store).use(router).mount('#app')
